import React from 'react';
import { Toaster } from 'react-hot-toast';
import { BrowserRouter, Navigate, NavLink, Route, Routes } from 'react-router-dom';
import { WalletProvider, useWallet } from './context/WalletContext';
import UserInfo from './pages/UserInfo';
import UserQuery from './pages/UserQuery';
import './App.css';

const WalletButton = () => {
    const { account, connectWallet, disconnectWallet } = useWallet();

    if (!account) {
        return (
            <button className="wallet-button" onClick={ connectWallet }>
                连接钱包
            </button>
        );
    }

    return (
        <div className="wallet-info">
            <span className="wallet-address">
                { account.slice(0, 6) }...{ account.slice(-4) }
            </span>
            <button className="wallet-button" onClick={ disconnectWallet }>
                断开
            </button>
        </div>
    );
};

const BottomNav = () => {
    return (
        <div className="bottom-nav">
            <NavLink
                to="/"
                end
                className={ ({ isActive }) => `nav-item${isActive ? ' active' : ''}` }
                style={ { textDecoration: 'none' } }
            >
                我的
            </NavLink>
            <NavLink
                to="/query"
                className={ ({ isActive }) => `nav-item${isActive ? ' active' : ''}` }
                style={ { textDecoration: 'none' } }
            >
                查询
            </NavLink>
        </div>
    );
};

const AppContent = () => {
    return (
        <div className="app">
            <header className="header">
                <div className="header-content">
                    <div className="logo-container">
                        <img src="/logo.png" alt="Logo" className="logo" />
                    </div>
                    <WalletButton />
                </div>
            </header>
            <main className="main-content">
                <Routes>
                    <Route path="/" element={ <UserInfo /> } />
                    <Route path="/query" element={ <UserQuery /> } />
                    <Route path="*" element={ <Navigate to="/" replace /> } />
                </Routes>
            </main>
            <BottomNav />
            <Toaster
                position="top-center"
                toastOptions={ {
                    duration: 3000,
                    style: {
                        background: '#2d2d2d',
                        color: '#fff',
                        border: '1px solid #9acd32'
                    },
                    success: {
                        iconTheme: {
                            primary: '#9acd32',
                            secondary: '#2d2d2d'
                        }
                    },
                    error: {
                        iconTheme: {
                            primary: '#ef4444',
                            secondary: '#2d2d2d'
                        }
                    }
                } }
            />
        </div>
    );
};

function App() {
    return (
        <WalletProvider>
            <BrowserRouter>
                <AppContent />
            </BrowserRouter>
        </WalletProvider>
    );
}

export default App;
